import React from "react";

import { Accordion, AccordionDetails, AccordionSummary, Avatar, Stack, Typography } from "@mui/material";

import { NewsDeal } from "./News";

interface Props {
  deals: NewsDeal[];
}

const DealItem: React.FC<{ deal: NewsDeal; index: number }> = ({ deal, index }) => (
  <Stack key={index} direction="row" gap="10px" alignItems="center">
    <Avatar variant="rounded" src={deal.avatarUrl} sx={{ width: 53, height: 53, borderRadius: "6px" }} />
    <Stack flex={1}>
      <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#071f35", lineHeight: "16px" }}>
        {deal.name}
      </Typography>
      <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#071f35", lineHeight: "16px" }}>
        Commitment required: {deal.commitment}, Estimated ROI: {deal.roi}
      </Typography>
      <Typography
        component="a"
        href="#"
        sx={{
          fontSize: "14px",
          fontWeight: 400,
          color: "#26a6ae",
          lineHeight: "16px",
          textDecoration: "none",
          cursor: "pointer"
        }}
      >
        See details
      </Typography>
    </Stack>
  </Stack>
);

export const NewsDeals: React.FC<Props> = ({ deals }) => {
  if (!deals || deals.length === 0) {
    return null;
  }

  const initialDeals = deals.slice(0, 2);
  const remainingDeals = deals.slice(2);
  const hasMoreDeals = deals.length > 2;

  return (
    <>
      <Stack
        sx={{
          borderBottom: hasMoreDeals ? "1px solid #dbe8f5" : "none",
          pb: hasMoreDeals ? "10px" : 0,
          gap: "10px"
        }}
      >
        {initialDeals.map((deal, index) => (
          <DealItem key={index} deal={deal} index={index} />
        ))}
      </Stack>
      {hasMoreDeals && (
        <Accordion
          sx={{
            boxShadow: "none",
            "&:before": {
              display: "none"
            },
            "&.Mui-expanded": {
              margin: 0
            }
          }}
        >
          <AccordionSummary
            expandIcon={null}
            sx={{
              padding: 0,
              minHeight: "auto",
              "& .MuiAccordionSummary-content": {
                margin: 0
              },
              "&.Mui-expanded": {
                minHeight: "auto"
              }
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 400,
                color: "#26a6ae",
                textDecoration: "none",
                cursor: "pointer"
              }}
            >
              See full list
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              padding: 0,
              paddingTop: "10px",
              paddingBottom: "10px"
            }}
          >
            <Stack
              sx={{
                gap: "10px"
              }}
            >
              {remainingDeals.map((deal, index) => (
                <DealItem key={index + 2} deal={deal} index={index + 2} />
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

